import { components, labelModes, services } from '@/utils'

import generatorRow from '@/components/generator/row'
import RoutesFormTitle from '@/components/services/routes/form/title'
import titleDivider from '@/components/title/divider'

function renderTitleField(h) {
  return h(
    RoutesFormTitle,
    {
      props: {
        value: this.proxy,
        serviceName: services.messageRuleGroups
      },
      on: {
        input: event => {
          this.proxy = event
        }
      }
    }
  )
}

function renderRulesField(h) {
  if (Array.isArray(this.proxy.MessageRules)) {
    return h(
      generatorRow,
      {
        props: {
          value: this.proxy.MessageRules,
          defaultValue: {
            id: undefined,
            priority: 0,
            $attach: true
          },
          sortable: true
        },
        scopedSlots: {
          row: ({ item }) => {
            const attrs = {}
            if (item.id) {
              attrs.href = `#/admin/messageProcessing/messageRules/${item.id}`
            }

            return h(
              'div',
              {
                class: 'grid faic',
                style: { 'grid-template-columns': '24px 1fr' }
              },
              [
                h(
                  'a',
                  {
                    attrs,
                    class: 'link link--passive square--24'
                  },
                  [
                    h(
                      'g-icon',
                      {
                        props: {
                          value: 'link',
                          color: 'grey'
                        }
                      }
                    )
                  ]
                ),

                h(
                  components.select,
                  {
                    props: {
                      value: item.id,
                      label: this.getTranslate(`${services.messageRuleGroups}.labels.rule`),
                      itemsDisabled: this.proxy.MessageRules.map(({ id }) => {
                        return id
                      }),
                      service: 'messageRules',
                      query: { isActive: true },
                      clearable: true,
                      labelMode: labelModes.hidden,
                      dense: true,
                      details: false,
                      autocomplete: true
                    },
                    on: {
                      input: event => {
                        item.id = event
                      }
                    }
                  }
                )
              ]
            )
          }
        },
        on: {
          input: event => {
            this.proxy.MessageRules = event
          }
        }
      }
    )
  }
}

export default function(h) {
  return h(
    'g-form',
    {
      class: 'grid',
      style: { 'grid-template-columns': '100%' }
    },
    [
      renderTitleField.call(this, h),
      h(titleDivider, { props: { value: this.getTranslate(`${services.messageRuleGroups}.subtitles.rules`) } }),
      renderRulesField.call(this, h)
    ]
  )
}
